import createLumirIcon from "../create-lumir-icon";

const Check = createLumirIcon("Check", [
  [
    "path",
    {
      key: "check",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "currentColor",
      d: "M7.8636 15.9999C7.5876 15.9999 7.32361 15.8859 7.13461 15.6849L2.27171 10.506C1.89272 10.104 1.91372 9.471 2.31571 9.09301C2.7187 8.71501 3.35169 8.73501 3.72868 9.13701L7.8536 13.5279L16.2614 4.32611C16.6354 3.91711 17.2674 3.89012 17.6754 4.26211C18.0824 4.6341 18.1104 5.26709 17.7384 5.67408L8.60158 15.6739C8.41458 15.8799 8.14859 15.9979 7.8706 15.9999H7.8636Z",
    },
  ],
]);

export default Check;
